import type React from 'react';
import type { FC } from 'react';

import Snackbar from '@crehana/ui/dist/Snackbar';
import type { State } from '@crehana/ui/dist/styles/states';

type SnackBarMessageProps = {
  isOpen: boolean;
  message: string;
  state?: State;
  isDark?: boolean;
};

const SnackBarMessage: FC<React.PropsWithChildren<SnackBarMessageProps>> = ({
  isOpen,
  message,
  state,
  isDark,
}) => (
  <Snackbar
    isDark={isDark}
    open={isOpen}
    message={message}
    position="top-right"
    state={state}
  />
);

export default SnackBarMessage;
